import React, { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router';
import Editor from './editor';

function PeoplesRouterEditor() {
  const navigate = useNavigate();
  const params = useParams();
  const onClose = useCallback(
    () => navigate('/candidates/'),
    [navigate],
  );
  const onSave = useCallback(
    (data) => navigate(`/candidates/${data.id}`),
    [navigate],
  );

  return (
    <Editor id={params.id} onClose={onClose} onSave={onSave} />
  );
}

export default PeoplesRouterEditor;
